export default __webpack_public_path__ + "static/media/LogoLight.hupso.bad7f04a.svg";